jQuery(function($) {
    /**
     * Optimizepress notice dismiss click event handler.
     * (see NotificationsController@dismiss)
     * 
     * @param {Object} e
     * @return {Void}
     */
    $(".wp-admin").on("click", ".ops-notice.is-dismissible .notice-dismiss", function(e) {
        var $notice = $(this).closest(".ops-notice");
        var dismissUrl = $notice.data("dismiss-url");

        $.ajax({
            method: 'get',
            url: dismissUrl,
            success: function(data) {},
            error: function(err) { console.error(err); }
        });

        e.preventDefault();
    });
});
